var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBigTriangles = function SvgBigTriangles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1512,
    height: 606,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "big-triangles_svg__a",
    width: 1512,
    height: 606,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3FCFB",
    stroke: "#00EA90",
    d: "M.5.5h1511v605H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#00EA90",
    strokeWidth: 6,
    mask: "url(#big-triangles_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1560.25 222.275c0 154.461-.06 318.824-.06 346.671 0 27.847-9.87 64.236-46.59 88.989-35.6 23.991-91.32 24.065-119.11-2.97-27.79-27.035-343.44-336.345-364.34-355.9-20.9-19.555-42.624-62.627-22.77-118.074 19.85-55.448 64.52-64.661 90.32-65.651 25.81-.99 323.59 0 355.35 0 31.76 0 57.57 4.951 76.43 22.773 23.95 22.636 30.77 44.556 30.77 84.162Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1454-29.57c0 102.754-.04 212.094-.04 230.619 0 18.525-6.56 42.733-30.99 59.2-23.68 15.959-60.75 16.008-79.24-1.976-18.49-17.985-228.47-223.75-242.37-236.76-13.91-13.008-28.36-41.66-15.15-78.547 13.2-36.886 42.92-43.015 60.09-43.673 17.16-.659 215.26 0 236.39 0 21.13 0 38.29 3.293 50.84 15.15C1449.46-70.5 1454-55.918 1454-29.57Z"
  }))));
};
export default SvgBigTriangles;